import { getPathAxes, getValueKeyAxes } from 'common/components/DataViz/charts/elements/paths/js/pathGeometry'
import { generateLine } from 'common/components/DataViz/charts/elements/paths/Line/js/generateLine'
import type { PathRendererProps } from 'common/components/DataViz/charts/elements/paths/Path.types'
import type { DataVizBaseProps } from 'common/components/DataViz/DataViz.types'
import type { UseParallelApiCallsStatus } from '../useParallelApiCalls'

export interface ChunkLineProps extends PathRendererProps,
  Pick<DataVizBaseProps, 'selected' | 'checkIfSelected' | 'grouping_key'> {
  start_time: number;
  end_time: number;
  status: UseParallelApiCallsStatus;
  colors?: Record<string, string>;
}

export const ChunkLine = ({ data = [], axes, status, colors, selected, checkIfSelected, grouping_key }: ChunkLineProps): JSX.Element | null => {
  if (!data.length) return null

  return (
    <>
      {getValueKeyAxes({ axes }).map(({ key, axes: key_axes }) => {
        if (grouping_key && checkIfSelected?.({ [grouping_key]: key }, 'path', selected, { grouping_key }) === false) return null
        const { x, y } = getPathAxes({ axes: key_axes })
        if (!x || !y) return null
        return (
          <path
            key={key}
            className={`demo-chunk-line line-path demo-chunk-line--${status}`}
            style={colors?.[key] ? { stroke: colors[key] } : undefined}
            d={generateLine({ data, x, y })}
          />
        )
      })}
    </>
  )
}
